import { render, staticRenderFns } from "./Suggest.vue?vue&type=template&id=6d744388"
import script from "./Suggest.vue?vue&type=script&lang=js"
export * from "./Suggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports